(function processBatchFindControllerDefinition() {
    'use strict';

    angular.module('ProcessBatch')
        .controller('ProcessBatchFindController', [
            '$q', '$filter', '$scope', '$state', 'errorsExtend', 'processBatchService', 'authExtend', '$translate', 'storageService', 'fileWorkflowService', 'alerts',
            function processBatchFindController($q, $filter, $scope, $state, errors, processBatchService, auth, $translate, storageService, fileWorkflowService, alerts) {

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.accordionState = {
                    isOpen: false
                };

                $scope.createFilters = function () {
                    var idOu = $scope.find.organizationalUnit ? $scope.find.organizationalUnit.id : undefined;
                    var processTypes = [];
                    if ($scope.find.processType != null) {
                        processTypes = [$scope.find.processType];
                    }

                    var filters = {
                        name: $scope.find.name,
                        processTypeId: processTypes,
                        organizationalUnitId: idOu,
                        processStatesIds: [],
                        dateFrom: $scope.find.dateFrom,
                        dateTo: $scope.find.dateTo,
                        createdBy: $scope.find.createdBy.metadataValue,
                        itemPerPage: $scope.data.itemPerPage,
                        page: $scope.data.currentPage
                    };

                    $scope.find.showNoData = false;

                    if ($scope.find.selectedStates && $scope.find.selectedStates.length > 0) {
                        $scope.find.selectedStates.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.id);
                        });
                    }

                    return filters;
                };

                $scope.executeFind = function () {
                    var filters = $scope.createFilters();
                    return processBatchService.advancedGet(filters).then(function (result) {
                        $scope.processes = [];
                        $scope.data.totalItems = result.count;
                        $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));
                        result.values.forEach(function (value) {
                            var r = value;

                            $scope.processes.push(r);
                        });

                        if ($scope.processes.length == 0) {
                            $scope.find.showNoData = true;
                        }

                        if ($scope.processes.length > 0) {
                            $scope.accordionState.isOpen = false;
                            $scope.find.showResult = true;
                            $scope.fillAccordion();
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.findAction = function () {
                    if (!$scope.processBatchFind.$valid) {
                        $scope.processBatchFind.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    storageService.setProcessBatchFilter($scope.find);

                    return $scope.executeFind();
                };

                $scope.view = function (process) {
                    $state.go('process-batch-detail', { id: process.id });
                };

                $scope.cleanFilters = function () {
                    $scope.accordionState.isOpen = true;
                    if ($scope.find.selectedStates) {
                        $scope.processStates = $scope.processStatesAux;
                    }

                    storageService.clearProcessBatchFilter();

                    $scope.find = storageService.getProcessBatchFilter();
                    $scope.processes = [];

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    };
                };

                $scope.fillAccordion = function () {
                    $scope.processes.forEach(function (paycheck) {
                        var accordionIsOpen = false;
                        Object.defineProperty(paycheck, "accordionIsOpen", {
                            get: function () { return accordionIsOpen; },
                            set: function (newValue) {
                                if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {
                                    if (event.target.offsetParent !== null && event.target.offsetParent.offsetParent.id === "p") {
                                        accordionIsOpen = newValue;
                                    }
                                }
                            }
                        });
                    });
                };

                $scope.selectProcessType = function (processType) {
                    $scope.find.processType = angular.copy(processType);
                    $scope.processes = [];
                    $scope.find.showResult = false;
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    };
                };

                $scope.checkUnCheckAll = function () {
                    if ($scope.processes.length > 0) {
                        $scope.processes.forEach(function (pc) {
                            pc.check = $scope.checkAll;
                        });
                    }
                };

                $scope.load = function () {
                    $scope.loading = false;
                    $scope.checkAll = false;
                    $scope.processStates = [];
                    $scope.items = [];
                    $scope.headers = [];

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    };

                    $scope.find = storageService.getProcessBatchFilter();
                    $scope.find.showResult = false;
                    $scope.find.createdBy = $scope.find.createdBy || { metadataLabel: '#ProcessCreatedBy', metadataValue: null };

                    $q.all([processBatchService.getProcessTypes(), processBatchService.getProcessStates()]).then(function (result) {

                        $scope.processTypes = result[0].value;
                        $scope.processStates = result[1].value;
                        $scope.processStatesAux = angular.copy($scope.processStates);

                        $scope.processStates = result[1].value.filter(function (item) {
                            if (!$scope.find.selectedStates) {
                                return true;
                            }

                            for (var i = 0; i < $scope.find.selectedStates.length; i++) {
                                if (item.id === $scope.find.selectedStates[i].id) { return false; }
                            };

                            return true;
                        });

                        if ($scope.processTypes.length === 1) {
                            $scope.selectProcessType($scope.processTypes[0].id);
                        }
                    });
                    return $scope.executeFind();
                };

                $scope.load();

            }]);
})();